<mat-tab-group>

  <mat-tab label="About">

      <h1 style="text-align:center">
        A novel longitudinal Multiple Overall Toxicity (MOTox) score to quantify adverse events<br> experienced by patients during chemotherapy treatment:<br>
a retrospective analysis of the MRC BO06 trial in osteosarcoma 
      </h1>

      <div fxLayout="row" fxLayoutAlign="space-around center">
        <img src="/assets/logo_Leiden_mate.png">
        <img src="/assets/logo-pmc.jpg">
        <img src="/assets/lumc-logo-en.jpg">
        <img src="/assets/logo_MOX.png">
        <img src="/assets/logo_Polimi.png">
      </div>
  </mat-tab>
  <!-- <mat-tab label="1st Cycle">

      <div class="form-container" fxLayout="column">
          <mat-spinner *ngIf="posting" class="spinner">
          </mat-spinner>

          <mat-form-field appearance="fill">
              <mat-label>Gender</mat-label>
              <mat-select [(ngModel)]="c1_sex" name="c1_sex" required>
                <mat-option *ngFor="let op of options.cycle1.sex" [value]="op.value">
                  {{op.view}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <br>


          <mat-form-field>
              <input required [(ngModel)]="c1_ht1" name="c1_ht1" matInput
                placeholder="Height of Patient (cm)" type="number">
            </mat-form-field>
            <br>
            
          <mat-form-field>
            <input required [(ngModel)]="c1_cumdose1" name="c1_cumdose1" matInput placeholder="Cumulative Dose (mg / m^2)"
              type="number">
          </mat-form-field>
          <br>
          <mat-divider></mat-divider>

          <mat-form-field>
            <input required [(ngModel)]="c1_plt11" name="c1_plt11" matInput
              placeholder="Platelets Pre-Cycle, 1st Measurement (*10^9 / L)" type="number">
          </mat-form-field>
          <br>
          <mat-form-field>
            <input required [(ngModel)]="c1_plt21" name="c1_plt21" matInput
            placeholder="Platelets Pre-Cycle, 2nd Measurement (*10^9 / L)" type="number">
          </mat-form-field>
          <br>
          <mat-divider></mat-divider>
          <mat-form-field>
              <input required [(ngModel)]="c1_wbc11" name="c1_wbc11" matInput
                placeholder="White Blood Count of Pre-Cycle, 1st Measurement (*10^9 / L)" type="number">
            </mat-form-field>
            <br>
            <mat-form-field>
              <input required [(ngModel)]="c1_wbc21" name="c1_wbc21" matInput
              placeholder="White Blood Count of Pre-Cycle, 2nd Measurement (*10^9 / L)" type="number">
            </mat-form-field>
            <br>
            <mat-divider></mat-divider>

          <mat-form-field>
              <input required [(ngModel)]="c1_neut11" name="c1_neut11" matInput
                placeholder="Neutrophils of Pre-Cycle, 1st Measurement (*10^9 / L)" type="number">
            </mat-form-field>
            <br>
            <mat-form-field>
                <input required [(ngModel)]="c1_neut21" name="c1_neut21" matInput
                  placeholder="Neutrophils of Pre-Cycle, 2nd Measurement (*10^9 / L)" type="number">
              </mat-form-field>
              <br>
              <mat-divider></mat-divider>

            <mat-form-field>
                <input required [(ngModel)]="c1_ren11" name="c1_ren11" matInput
                  placeholder="Renal Clearance of Pre-Cycle, 1st Measurement (ml/min/1.73m^2)" type="number">
              </mat-form-field>
              <br>
            
             
          <mat-divider></mat-divider>
          <mat-card fxAlign="center top" *ngIf="hasResults.cycle1">
            <h3>
              Probability of High Toxicity: {{results.cycle1}}
            </h3>
            <h4 class="side-info">
              Sensitivity: 0.6164 | Specificity: 0.6239
            </h4>
          </mat-card>
        </div>
        <div class="form-container">
          <button [disabled]="posting" (click)="onSubmit1()" mat-stroked-button color="primary">Predict Toxicity
            Index</button>
        </div>

  </mat-tab> -->
  <mat-tab label="2nd Cycle">
    <div class="form-container" fxLayout="column">
      <mat-spinner *ngIf="posting" class="spinner">
      </mat-spinner>
      <mat-form-field appearance="fill">
        <mat-label>Previous Toxicity (Level)</mat-label>
        <mat-select [(ngModel)]="c2_highotox1" name="c2_highotox1" required>
          <mat-option *ngFor="let op of options.cycle2.tox1" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Treatment (Regimen)</mat-label>
        <mat-select [(ngModel)]="c2_trt" name="c2_trt" required>
          <mat-option *ngFor="let op of options.cycle2.trt" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c2_stdcumdose2" name="c2_stdcumdose2" matInput
          placeholder="Achieved Cumulative Dose (mg/m^2)" type="number">
      </mat-form-field>
      
      <br>
      <mat-divider></mat-divider>
      <mat-form-field>
        <input required [(ngModel)]="c2_wbc1" name="c2_wbc1" matInput
          placeholder="White Blood Count at randomization (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c2_wbc2" name="c2_wbc2" matInput
          placeholder="White Blood Count During Current (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-card fxAlign="center top" *ngIf="hasResults.cycle2">
        <h3>
          Probability of High Toxicity: {{results.cycle2}}
        </h3>
        <h4 class="side-info">
          Sensitivity: 0.68085 | Specificity: 0.66667
        </h4>
      </mat-card>
    </div>
    <div class="form-container">
      <button [disabled]="posting" (click)="onSubmit2()" mat-stroked-button color="primary">Predict Toxicity
        Index</button>
    </div>


  </mat-tab>
  <mat-tab label="3rd Cycle">

    <div class="form-container" fxLayout="column">
      <mat-spinner *ngIf="posting" class="spinner">
      </mat-spinner>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 1st Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c3_highotox1" name="c3_highotox1" required>
          <mat-option *ngFor="let op of options.cycle3.tox1" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 2nd Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c3_highotox2" name="c3_highotox2" required>
          <mat-option *ngFor="let op of options.cycle3.tox2" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c3_stdcumdose3" name="c3_stdcumdose3" matInput placeholder="Achieved Cumulative Dose (mg/m^2)"
          type="number">
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c3_plt1" name="c3_plt1" matInput
          placeholder="Platelets at randomization (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c3_plt3" name="c3_plt3" matInput
          placeholder="Platelets before the beginning of current cycle  (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <mat-card fxAlign="center top" *ngIf="hasResults.cycle3">
        <h3>
          Probability of High Toxicity: {{results.cycle3}}
        </h3>
        <h4 class="side-info">
          Sensitivity: 0.70391 | Specificity: 0.66162
        </h4>
      </mat-card>
    </div>
    <div class="form-container">
      <button [disabled]="posting" (click)="onSubmit3()" mat-stroked-button color="primary">Predict Toxicity
        Index</button>
    </div>

  </mat-tab>
  <mat-tab label="4th Cycle">

    <div class="form-container" fxLayout="column">
      <mat-spinner *ngIf="posting" class="spinner">
      </mat-spinner>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 1st Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c4_highotox1" name="c4_highotox1" required>
          <mat-option *ngFor="let op of options.cycle4.tox1" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 2nd Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c4_highotox2" name="c4_highotox2" required>
          <mat-option *ngFor="let op of options.cycle4.tox2" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 3rd Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c4_highotox3" name="c4_highotox3" required>
          <mat-option *ngFor="let op of options.cycle4.tox3" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Gender</mat-label>
        <mat-select [(ngModel)]="c4_gender" name="c4_gender" required>
          <mat-option *ngFor="let op of options.cycle4.gender" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c4_wbc1" name="c4_wbc1" matInput
          placeholder="White Blood Count at randomization (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c4_wbc4" name="c4_wbc4" matInput
          placeholder="White Blood Count before the beginning of current cycle (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c4_wbc4_2" name="c4_wbc4_2" matInput
          placeholder="White Blood Count at the planned nadir of current cycle (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c4_plt1" name="c4_plt1" matInput
          placeholder="Platelets at randomization (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c4_plt4" name="c4_plt4" matInput
          placeholder="Platelets before the beginning of current cycle (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c4_neut4" name="c4_neut4" matInput
          placeholder="Neutrophils before the beginning of current cycle (x 10^9/L)" type="number">
      </mat-form-field>
      <mat-divider></mat-divider>
      <mat-card fxAlign="center top" *ngIf="hasResults.cycle4">
        <h3>
          Probability of High Toxicity: {{results.cycle4}}
        </h3>
        <h4 class="side-info">
          Sensitivity: 0.67391 | Specificity: 0.71503
        </h4>
      </mat-card>
    </div>
    <div class="form-container">
      <button [disabled]="posting" (click)="onSubmit4()" mat-stroked-button color="primary">Predict Toxicity
        Index</button>
    </div>

  </mat-tab>
  <mat-tab label="5th Cycle">
    <div class="form-container" fxLayout="column">
      <mat-spinner *ngIf="posting" class="spinner">
      </mat-spinner>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 3rd Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c5_highotox3" name="c5_highotox3" required>
          <mat-option *ngFor="let op of options.cycle5.tox3" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 4th Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c5_highotox4" name="c5_highotox4" required>
          <mat-option *ngFor="let op of options.cycle5.tox4" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Gender</mat-label>
        <mat-select [(ngModel)]="c5_gender" name="c5_gender" required>
          <mat-option *ngFor="let op of options.cycle5.gender" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c5_wbc1" name="c5_wbc1" matInput
          placeholder="White Blood Count at randomization (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c5_wbc5" name="c5_wbc5" matInput
          placeholder="White Blood Count before the beginning of current cycle (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c5_wbc5_2" name="c5_wbc5_2" matInput
          placeholder="White Blood Count at the planned nadir of current cycle (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>

      <mat-card fxAlign="center top" *ngIf="hasResults.cycle5">
        <h3>
          Probability of High Toxicity: {{results.cycle5}}
        </h3>
        <h4 class="side-info">
          Sensitivity: 0.69942 | Specificity: 0.70098
        </h4>
      </mat-card>
    </div>
    <div class="form-container">
      <button [disabled]="posting" (click)="onSubmit5()" mat-stroked-button color="primary">Predict Toxicity
        Index</button>
    </div>

  </mat-tab>
  <mat-tab label="6th Cycle">
    <div class="form-container" fxLayout="column">
      <mat-spinner *ngIf="posting" class="spinner">
      </mat-spinner>

      <mat-form-field appearance="fill">
        <mat-label>Toxicity 2nd Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c6_highotox2" name="c6_highotox2" required>
          <mat-option *ngFor="let op of options.cycle6.tox2" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 3rd Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c6_highotox3" name="c6_highotox3" required>
          <mat-option *ngFor="let op of options.cycle6.tox3" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 4th Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c6_highotox4" name="c6_highotox4" required>
          <mat-option *ngFor="let op of options.cycle6.tox4" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Toxicity 5th Cycle (Level)</mat-label>
        <mat-select [(ngModel)]="c6_highotox5" name="c6_highotox5" required>
          <mat-option *ngFor="let op of options.cycle6.tox5" [value]="op.value">
            {{op.view}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c6_wbc1" name="c6_wbc1" matInput
          placeholder="White Blood Count at randomization (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c6_wbc6_2" name="c6_wbc6_2" matInput
          placeholder="White Blood Count at the planned nadir of current cycle (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c6_plt1" name="c6_plt1" matInput
          placeholder="Platelets Count at randomization (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-form-field>
        <input required [(ngModel)]="c6_plt6" name="c6_plt6" matInput
          placeholder="Platelets Count before the beginning of current cycle (x 10^9/L)" type="number">
      </mat-form-field>
      <br>
      <mat-divider></mat-divider>
      <mat-card fxAlign="center top" *ngIf="hasResults.cycle6">
        <h3>
          Probability of High Toxicity: {{results.cycle6}}
        </h3>
        <h4 class="side-info">
          Sensitivity: 0.71739 | Specificity: 0.76569
        </h4>
      </mat-card>
    </div>
    <div class="form-container">
      <button [disabled]="posting" (click)="onSubmit6()" mat-stroked-button color="primary">Predict Toxicity
        Index</button>
    </div>

  </mat-tab>

</mat-tab-group>